import { useCallback, useEffect, useState } from 'react';
import { useAdminApi, ApiError } from '../../../Admin/shared/adminApi';
import type { FriendUsersResponse, UserSortKey } from './types';

export interface FriendUsersFilters {
  from?: string;
  to?: string;
  q?: string;
  sort?: UserSortKey;
  order?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
}

export function useFriendUsers(filters: FriendUsersFilters) {
  const { request } = useAdminApi();
  const [data, setData] = useState<FriendUsersResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(
        await request<FriendUsersResponse>({
          env: 'prod',
          path: '/admin/analytics/friends/users',
          query: filters as Record<string, string | number | undefined>,
        }),
      );
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Failed to load users');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [request, JSON.stringify(filters)]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    void load();
  }, [load]);

  return { data, error, loading, reload: load };
}
